<template>
  <div class="mt-5">
    <template v-if="source.KategoriaInditoFl">
      <div class="ck-content kategoria-indito-wrapper">
        <div class="card-single-post mb-3">
          <img :src="source.Kep + '?h=400'" :alt="source.Cim" />
          <div class="card-single-post-infos">
            <div class="card-single-post-infos-inner">
              <h1 class="mb-3">
                {{ source.Cim }}
              </h1>
              <p class="hirismerteto">
                {{ source.Ismerteto }}
              </p>
              <div class="card-single-post-author">
                <v-img
                  :src="
                    source.Szerzo.Kep
                      ? source.Szerzo.Kep + '?w=32&h=32'
                      : $placeholderImage
                  "
                  height="32px"
                  max-height="32px"
                  width="32px"
                  max-width="32px"
                  class="rounded"
                >
                </v-img>
                <span class="dot-separator white mx-2"></span>
                <span>{{ source.Szerzo.Nev }}</span>
                <span class="dot-separator white mx-2"></span>
                <span class="white--text">{{
                  source.MegjelenesDatuma | toShortDate
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="mb-3 kategoria-indito-tartalom"
          v-html="source.Tartalom"
        ></div>
        <div class="mb-3">
          <v-btn
            text
            outlined
            color="primary"
            class="br-0"
            :to="{
              name: 'Hir',
              params: {
                id: source.Azonosito,
              },
            }"
          >
            Elolvasom a teljes cikket >
          </v-btn>
        </div>
      </div>
    </template>
    <v-list-item
      v-else
      class="d-block px-0"
      :class="{ 'kategoria-indito': source.KategoriaInditoFl }"
      :to="{
        name: 'Hir',
        params: {
          id: source.Azonosito,
        },
      }"
    >
      <v-list-item-content>
        <div class="flex-center-between w-100">
          <div class="d-flex align-center pr-3">
            <v-img
              height="75px"
              width="100px"
              min-height="75px"
              min-width="100px"
              max-height="150"
              :src="source.Kep ? source.Kep + '?h=75' : $placeholderImage"
              class="mr-4"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <div class="d-flex flex-column justify-space-between">
              <v-list-item-title>{{ source.Cim }}</v-list-item-title>
              <p class="mb-3 font-size-md">{{ source.Ismerteto }}</p>
              <v-list-item-subtitle>
                <p class="d-flex flex-wrap align-center mb-0">
                  {{ source.Szerzo.Nev }}
                  <span class="dot-separator grey darken-2 mx-2"></span>
                  <k-live-timestamp
                    v-if="isElozmeny"
                    :value="source.UtolsoOlvasasDatuma"
                  ></k-live-timestamp>
                  <k-live-timestamp
                    v-else
                    :value="source.MegjelenesDatuma"
                  ></k-live-timestamp>
                </p>
              </v-list-item-subtitle>
            </div>
          </div>
          <k-fontos-hir-icon color="primary" :hir="source"></k-fontos-hir-icon>
        </div>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'k-hir-lista-item',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {},
  props: {
    index: {
      type: Number,
    },
    source: {
      type: Object,
      default() {
        return {};
      },
    },
    isElozmeny: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
